// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__7oRX1","header":"ReportDetails_header__1btwV","title":"ReportDetails_title__2KfDj","left":"ReportDetails_left__2fR_I"};